<template>
  <div
    class="home-layout"
    :class="[
      $route.meta.showTabBar ? 'show-tab-bar' : ''
    ]"
  >
    <div class="main-content-container">
      <router-view />
    </div>
    <home-tab-bar v-show="$route.meta.showTabBar" />
  </div>
</template>

<script>
import HomeTabBar from '@/views/layout/components/HomeTabBar'
export default {
  name: 'HomeLayout',
  components: { HomeTabBar }
}
</script>

<style lang="less" scoped>
.home-layout {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  &.show-tab-bar {
   > .main-content-container {
     height: calc(100% - 60px);
    }
  }
  > .main-content-container {
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar {/*滚动条整体样式*/
      width: 2px;     /*高宽分别对应横竖滚动条的尺寸*/
    }
    &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
      background: rgba(0,0,0,0.2);
    }
  }
}
</style>
